// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9d521569","455":"0de4dcb7"}[chunkId] + ".chunk.js";
};